<template>
    <div id="modelShowList" :class="$root.isMob() ? 'mob' : ''" :style="isHome?'box-shadow:unset;margin-top: 0 !important;padding-top: 0 !important;':''">
        <h2 v-if="!isHome"><i class="el-icon-s-order icon"></i>
            模型展示
        </h2>
        <div class="list">
            <div class="item" v-for="item in data" :key="item.id" @click="showDetail(item.id)">
                <div class="img">
                    <img v-if="item.photos" :src="apiUrl+item.photos.split(',')[0]"/>
                    <div class="placeholderImg" v-if="!item.photos">暂无图片</div>
                </div>
                <div class="name">{{ item.name }}</div>
            </div>
            <div class="empty" v-if="data.length == 0">
                <el-empty description="暂无数据"></el-empty>
            </div>
        </div>
        <div class="pageList">
            <el-pagination :pager-count="$root.isMob ? 5 : 7" background layout="prev, pager, next" :current-page="currentPage" :page-count="pageNum" @current-change="changePage"></el-pagination>
        </div> 
    </div>
</template>

<script>

export default {
    name: 'modelShowList',
    props: {
        "isHome" : {
            type: Boolean,
            default: false
        }
    },
    components: {
    },
    data() {
        return {
            data:[],
            dataImgs:[],
            canBeShowImg:false,
            modId:-1,
            apiUrl:window.config.api,
            currentPage:1,
            pageNum:1,
        }
    },
    created() {
        this.getModelList();
    },
    mounted() {
        
    },
    beforeDestroy() {
        
    },
    watch: {
        "dataImgs" () { 
            if(this.dataImgs.length == this.data.length && this.data.length > 0){
                this.canBeShowImg = true;
            }
        },
    },
    methods: {
        changePage(page){
            this.getModelList(page);
        },
        async getModelList(page=1){
            this.loading = true;
            let data = await this.$root.getModelList(page,10);   
            this.data = data.data;
            this.pageNum = data.last_page;
            this.getFrameImg();
            this.linkUrl = data.length > 0?data[0].link_url:"";
            this.loading = false;
        },
        showDetail(id) {
            this.$emit('showDetail',id)
        },
        // 截图每个视频的第一帧作为封面图
        getFrameImg() {
            this.data.forEach(item => {
                let video = document.createElement('video');
                video.src = this.apiUrl+item.normal_url;
                video.crossOrigin = 'anonymous'; // 避免跨域问题

                video.addEventListener('loadeddata', () => {
                    this.getFrameAtSecond(this.apiUrl+item.normal_url, 2, (img) => {
                        this.dataImgs.push(img);
                    });
                });

                // 错误处理（可选）
                video.addEventListener('error', (e) => {
                    console.error(`视频加载失败: ${item.normal_url}`, e);
                });
            });            
        },
        getFrameAtSecond(videoUrl, second = 1, callback, retryCount = 0) {
            const MAX_RETRIES = 2;

            const video = document.createElement('video');
            video.crossOrigin = 'anonymous';
            video.preload = 'auto';
            video.src = videoUrl;
            video.muted = true; // 有些浏览器不允许未静音播放
            video.playsInline = true;
            video.style.display = 'none';
            document.body.appendChild(video);

            const cleanUp = () => {
                video.pause();
                video.src = '';
                document.body.removeChild(video);
            };

            video.addEventListener('loadedmetadata', () => {
                if (second > video.duration) second = video.duration - 0.1;
                video.currentTime = second;
            });

            video.addEventListener('seeked', () => {
                // 等待帧稳定后截图
                setTimeout(() => {
                    const canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                    // 检查像素是否全黑或透明
                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    let allBlack = true;
                    for (let i = 0; i < imageData.data.length; i += 4) {
                        const [r, g, b, a] = [
                            imageData.data[i],
                            imageData.data[i + 1],
                            imageData.data[i + 2],
                            imageData.data[i + 3]
                        ];
                        if (r + g + b > 10 && a > 10) { // 有内容
                            allBlack = false;
                            break;
                        }
                    }

                    if (allBlack && retryCount < MAX_RETRIES) {
                        console.warn('截图失败（黑屏），重试中...', retryCount + 1);
                        cleanUp();
                        setTimeout(() => {
                            this.getFrameAtSecond(videoUrl, second, callback, retryCount + 1);
                        }, 500);
                        return;
                    }

                    const img = canvas.toDataURL('image/jpeg');
                    callback && callback(img);
                    cleanUp();
                }, 300); // 稍微延迟，确保帧已解码
            });
        }
    }
}
</script>

<style lang="scss" scoped src="@/assets/css/lib/modelShowList.scss"></style>